import './modalContent.css'

export default function Camper() {
  return (
    <div className='modal-content'>
      <h2 className='modal-header'>The Great Outdoors: My Adventures in Nature</h2>
      <div className='modal-body'>
        <p>
          There's something magical about the great outdoors, and I, along with my wife, cherish every moment we spend
          exploring the stunning landscapes of southwest Missouri and northwest Arkansas. Our adventures often begin
          with our trusty camper, which serves as a launchpad into the natural wonders of the Ozarks.
        </p>

        <h3>🏕️ Camping in the Ozarks</h3>
        <p>
          Our camper isn't just a vehicle; it's our gateway to countless memories under the open skies. It's where we
          start our journey to witness the serene beauty and tranquility of the Ozarks. Each camping trip is an
          opportunity to disconnect from the daily grind and reconnect with nature.
        </p>

        <h3>🚶‍♂️ Hiking Through Nature's Canvas</h3>
        <p>
          The trails of southwest Missouri and northwest Arkansas are like the veins of the Earth, guiding us through
          breathtaking scenery and untouched wilderness. Hiking these paths allows us to intimately experience the
          diverse landscapes, from dense woods to panoramic vistas.
        </p>

        <h3>🏞️ Exploring Caves and Waters</h3>
        <p>
          Our excursions often lead us to mysterious and awe-inspiring caves, where the secrets of the Earth lie hidden
          in the shadows. The rivers and lakes in the area are our sanctuaries, offering us moments of peace as we spend
          time on their banks or gently glide over their serene waters.
        </p>
        <hr
          style={{
            color: 'white',
            width: '25%',
            marginTop: '25px',
            marginBottom: '25px',
          }}
        />
        <p>
          These outdoor escapades are more than just hobbies; they are a testament to my love for nature and adventure.
          They rejuvenate my spirit and inspire my work, adding depth and color to the creations I bring to life in the
          digital world. So, as you explore Tim's Planet, know that the inspiration behind it is drawn from the very
          heart of nature's splendor.
        </p>

        <p>
          Thank you for joining me on this journey. Whether it's traversing digital landscapes or hiking through the
          natural beauty of the Ozarks, there's always an adventure waiting around the corner!
        </p>
      </div>
    </div>
  )
}
